import { useEffect, useState } from "react";
import { Eye, EyeOff, X, Loader2 } from "lucide-react";
import { useLogin } from "../hooks/useAuth";
import logo from "../images/healo.png";

const fieldClass =
  "w-full bg-transparent border-b border-black/15 dark:border-white/20 focus:border-[#8C7CF0] outline-none text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-white/30 text-sm py-2.5 transition-colors duration-200";

const LoginPopup = ({ open, onClose, onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { handleLogin, loading, error } = useLogin();
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  if (!open) return null;
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await handleLogin(email, code, password);

      onLoginSuccess?.();

      // Reload the app so AuthContext picks up the new localStorage values
      window.location.reload();
    } catch (err) {}
  };
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 dark:bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-xs rounded-3xl border border-black/[0.08] dark:border-white/[0.08] bg-white dark:bg-[#14151F]/95
                   backdrop-blur-2xl shadow-2xl shadow-black/10 dark:shadow-black/50 p-6 animate-[popIn_.25s_cubic-bezier(.22,1,.36,1)]"
      >
        <style>{`
          @keyframes popIn { from { opacity: 0; transform: scale(.96) translateY(6px); } to { opacity: 1; transform: scale(1) translateY(0); } }
        `}</style>

        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 text-slate-400 dark:text-white/40 hover:text-slate-900 dark:hover:text-white transition-colors duration-200"
        >
          <X size={18} />
        </button>

        <div className="flex flex-col items-center mb-4">
          <img src={logo} alt="Logo" className="w-16 mb-3" />
          <h2 className="font-['Space_Grotesk',_sans-serif] text-lg font-semibold text-slate-900 dark:text-white">
            Sign in
          </h2>
        </div>

        <form onSubmit={onSubmit} className="flex flex-col gap-5">
          <div>
            <label className="text-[11px] uppercase tracking-wide text-slate-400 dark:text-white/40">
              Email Address
            </label>
            <input
              autoFocus
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={fieldClass}
              placeholder="you@company.com"
            />
          </div>

          <div>
            <label className="text-[11px] uppercase tracking-wide text-slate-400 dark:text-white/40">
              Code
            </label>
            <input
              type="text"
              required
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className={fieldClass}
              placeholder="Access code"
            />
          </div>

          <div>
            <label className="text-[11px] uppercase tracking-wide text-slate-400 dark:text-white/40">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={fieldClass + " pr-8"}
                placeholder="••••••••"
              />
              <button
                type="button"
                onClick={() => setShowPassword((p) => !p)}
                className="absolute right-0 top-1/2 -translate-y-1/2 text-slate-400 dark:text-white/40 hover:text-slate-900 dark:hover:text-white transition-colors duration-200"
              >
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          {error && <p className="text-[#FF5C7A] text-xs">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="mt-1 w-full py-2.5 rounded-xl bg-[#8C7CF0] text-white text-sm font-semibold
                       hover:bg-[#7A6BE0] active:scale-[.98] transition-all duration-150
                       disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};
var LoginPopup_default = LoginPopup;
export { LoginPopup_default as default };
